import React, {useState} from 'react'
import './tryToday.scss'
import {useMediaQuery} from 'react-responsive'
import {useHistory} from "react-router-dom"

import Button from '../../../../components/button/Button'
import TRY_NOW_POLYGON from '../../../../assets/TRY_NOW_POLYGON.png'
import VO_SMILING_FEMALE from '../../../../assets/VO_SMILING_FEMALE.png'

const TryToday = () => {
    const isMobile = useMediaQuery({maxWidth: 755})
//   const [company, setCompany] = useState('')
    const history = useHistory();

//   const handleChange = (e) => {
//     e.preventDefault()
//     setCompany(e.target.value)
//   }

    return (
        <div className="try_today__section">
            <img className="try_today__section__polygon" src={TRY_NOW_POLYGON} alt=""/>
            <div className="try_today__section__wrapper">
                <h1 className="try_today__section__wrapper__heading primary__heading">We
                    want to hear from you!</h1>
                <p>Setup a free consultation to see how we can help you streamline your
                    communication needs.</p>

                <p>We promise to offer you a ton of value without a huge sales pitch or
                    high pressure.</p>
                <div>
                    <Button text="Book Live Demo"
                            type={isMobile ? 'primary' : 'secondary'} onclick={() => {
                                window.open('https://calendly.com/virtualenterprise/30min?month=2021-06', '_blank');
                    }}/>
                </div>
            </div>
            {isMobile && <img className="smiling_female" src={VO_SMILING_FEMALE} alt=""/>}
        </div>
    )
}

export default TryToday
